import { Button, Col, Form, Row, Select, Skeleton, Tooltip } from "antd";
import React, { FC, useEffect, useRef, useState } from "react";
import AppScreen from "screens/teacher/ScreenWithSidebar";

//!COMPONENTS

//!STYLES
import { RedoOutlined } from "@ant-design/icons";
import { findFilterQuizOfCoursesStudent } from "api/services/studentQuizz/studentQuizz.services";
import { PlayLevel, StatusCode, UserRoles } from "common/enums";
import AppResult from "components/appResults";
import Breadcrumbs from "components/breadcrumbs";
import AppButton from "components/libs/button";
import * as appRoutes from "config/routes.config";
import useGetQuiz from "hooks/useGetQuizz";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import HeaderComponents from "screens/student/components/headerComponents";
import TeacherHeaderstabs from "../components/TeacherHeaderstabs";
import CardQuizz from "../components/cardQuizz";
import s from "./assets/easyQuiz.module.css";

const FindQuizForChapter: FC = () => {
  const { idCours } = useSelector((state: any) => state.courses);
  const { id, level } = useParams();
  const navigate = useNavigate();
  const { loading, data, setData, setLoading } = useGetQuiz(id!, level!);
  // const { quizForCours, isloading, error } = useQuizzForCours(idCours);
  //
  const refSubmited = useRef<any>();
  const { user } = useSelector((state) => state.auth);
  const { userHavingCalendar, userTeachingOrganismClass } = useSelector((state) => state.app);
  const isTeacher = user?.roles?.includes(UserRoles.TEACHER);

  const isFirstRender = useRef(true);

  const [form] = Form.useForm();
  const [quizLevel, setQuizLevel] = useState<string>("");
  const [quizDuration, setQuizDuration] = useState<string>("");

  const { Option } = Select;

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  const filterQuiz = async () => {
    setLoading(true);
    try {
      const response = await findFilterQuizOfCoursesStudent(
        id!,
        quizLevel,
        quizDuration.split(".")[0],
        quizDuration.split(".")[1]
      );

      if (response?.statusCode === StatusCode.OK) {
        setData(response?.data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const onReset = () => {
    form.resetFields(['quizzLevel', 'duration']);
    setQuizLevel("");
    setQuizDuration("");
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    filterQuiz();
  }, [quizLevel, quizDuration]);

  return (
    <React.Fragment>
      <div style={{ marginTop: isMobile && user?.roles?.includes(UserRoles.TEACHER) ? (!userHavingCalendar || userTeachingOrganismClass) ? "125px" : "70px" : "0px" }}>
        <Breadcrumbs isMycontent={true} />
        <AppScreen className={s.easyQuiz}>

          <HeaderComponents />

          <TeacherHeaderstabs level={level} onRequest={() => { }} onExit={() => { }} />

          <div className={s.header}>
            <div className="left">
              <span style={{ color: "var(--first-color)" }}>
                {data.length} Quiz trouvé(s) - {level}
              </span>
            </div>

            <div>
              <Form
                name="basic"
                autoComplete="off"
                form={form}
              /* onFieldsChange={filterQuiz} */
              >
                <Row gutter={12} align="middle" className={s.formElement}>
                  <Col>
                    <div className={`${s.select}`}>
                      <Form.Item name="quizzLevel">
                        <Select placeholder="Niveau quiz" bordered={false} onChange={(value: any) => setQuizLevel(value)}>
                          <Option value={PlayLevel.EASY}>{PlayLevel.EASY}</Option>
                          <Option value={PlayLevel.MEDIUM}>
                            {PlayLevel.MEDIUM}
                          </Option>
                          <Option value={PlayLevel.HARD}>{PlayLevel.HARD}</Option>
                          <Option value="">Tous les quiz</Option>
                        </Select>
                      </Form.Item>
                    </div>
                  </Col>

                  <Col>
                    <div className={`${s.select}`}>
                      <Form.Item name="duration">
                        <Select placeholder="Durée" bordered={false} onChange={(value: any) => setQuizDuration(value)}>
                          <Option value={"5.10"}>5 - 10 min</Option>
                          <Option value={"10.20"}>10 - 20 min</Option>
                          <Option value={"20.30"}>20 - 30 min</Option>
                          <Option value={"30.60"}>Plus de 30 min</Option>
                        </Select>
                      </Form.Item>
                    </div>
                  </Col>
                  {isTeacher && user?.isActive && user?.step === "completed" && !isMobile && <Col>
                    <Link to={appRoutes.TEACHER_CREATE__QUIZ}>
                      <AppButton>Proposer un quiz</AppButton>
                    </Link>
                  </Col>}
                </Row>

                <Tooltip placement="left" title={"Réinitialiser tous les filtres"}>
                  <Button
                    className={s.__reset__btn}
                    onClick={onReset}
                    shape="circle"
                    htmlType="button"
                  >
                    <RedoOutlined />
                  </Button>
                </Tooltip>
              </Form>
            </div>
          </div>

          <div className={s.main}>
            {loading && (
              <div>
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
              </div>
            )}

            {!loading && (
              <div className={s.quizBox}>
                {data?.result.map((quiz: any, i: number) => (
                  <React.Fragment key={i}>
                    <CardQuizz quizz={quiz} />
                  </React.Fragment>
                ))}
              </div>
            )}

            {!loading && data?.result?.length <= 0 && (
              <AppResult status="info" title="Aucun quiz disponible pour le moment!" />
            )}
          </div>
        </AppScreen>
      </div>
    </React.Fragment>
  );
};

export default FindQuizForChapter;
